import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTheme, useMediaQuery, Grid } from '@mui/material';

// Custom Components
import PublicPage from '@/ui/PublicPage/PublicPage';

function InfoPage() {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down('md'));

  const lgDown: boolean = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <PublicPage overrideBgImage>
      <Box width='100%'>
        <Container maxWidth='xxl' style={{ padding: 0 }}>
          <Grid container p={isMobile ? 3 : 10}>
            <Grid size={{ xs: 12, md: 5, lg: 3 }}>
              <Typography
                color='primary'
                variant='h4'
                component='h1'
                sx={{
                  position: !isMobile ? 'fixed' : 'unset',
                }}
              >
                {t('public.project_info')}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 7, lg: 9 }} container mt={isMobile ? 2 : 0} columnGap='50px'>
              <Grid size={{ xs: 12, lg: 7 }}>
                <Box>
                  <Typography component="p" sx={{ mb: 2 }} variant="body1" fontSize='1.2rem'>
                    {t('public.info_page_text_1')}
                  </Typography>
                  <Typography component="p" sx={{ mb: 2 }} variant="body1" fontSize='1.2rem'>
                    {t('public.info_page_text_2')}
                  </Typography>
                  <Typography component="p" sx={{ mb: 2 }} variant="body1" fontSize='1.2rem'>
                    {t('public.info_page_text_3')}
                  </Typography>
                </Box>
                {lgDown ? (
                  <Box maxWidth='500px'>
                    <img width='100%' alt="logos" src="images/logos_welcome.png" />
                  </Box>
                ) : null}
                <Box textAlign='left' mt={3}>
                  <Typography variant="h6">{t('public.headings.contact')}</Typography>
                  <Typography
                    component="a"
                    href={`mailto:${t('public.contact.email')}`}
                    target="_blank"
                    sx={{
                      color: 'primary.main',
                      textDecoration: 'underline',
                    }}
                  >
                    {t('public.contact.email')}
                  </Typography>
                </Box>
                <Box textAlign='left' mt={3}>
                  <Typography variant="h6">{t('public.headings.impresum')}</Typography>
                  <Typography variant="body1">
                    {t('public.impressum.project_leader')}: Jasmina Benčić Martinjak ({t('common.hgss')})
                  </Typography>
                  <Typography variant="body1">{t('public.impressum.cartography_associate')}: Dragan Tasić</Typography>
                  <Typography variant="body1">
                    {t('public.impressum.dev')}:{' '}
                    <a
                      href="https://prehnit.hr"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: 'primary.main',
                        textDecoration: 'underline',
                      }}
                    >
                      Prehnit {t('common.doo')}
                    </a>
                    <style>
                      {`
                    a:visited {
                      color: ${theme.palette.secondary.main};
                    }
                  `}
                    </style>
                  </Typography>
                  <Typography variant="body1">{t('public.impressum.dev_arch')}: Vlatko Roland</Typography>
                  <Typography variant="body1">{t('public.impressum.dev_lead')}: Vanja Suhina</Typography>
                  <Typography variant="body1">{t('public.impressum.design')}: Damir Prizmić</Typography>
                  <Typography variant="body1">{t('public.impressum.hps_associates')}</Typography>
                </Box>
              </Grid>
              {!lgDown ? (
                <Grid size={{ xs: 12, lg: 4 }}>
                  <Box maxWidth='300px'>
                    <img width='100%' alt="logos" src="images/logos_about.png" />
                  </Box>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </Container>
      </Box>
    </PublicPage>
  );
}

export default InfoPage;
